var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from "vue";
import TypeCheck from "../common/TypeCheck";
import mixins from "../common/Mixin";
var VueDialog = (function (_super) {
    __extends(VueDialog, _super);
    function VueDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VueDialog.prototype.$closeDialog = function () {
        if ('$dialogIndex' in this && TypeCheck.isNumber(this.$dialogIndex)) {
            layer.close(this.$dialogIndex);
        }
    };
    VueDialog.prototype.$styleDialog = function (style, title) {
        if ('$dialogIndex' in this && TypeCheck.isNumber(this.$dialogIndex)) {
            layer.style(this.$dialogIndex, __assign({}, style));
            if (title) {
                layer.title(title, this.$dialogIndex);
            }
        }
    };
    return VueDialog;
}(Vue));
export { VueDialog };
mixins(Vue, VueDialog);
export default VueDialog;
